import React, { useState, useEffect, useRef } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

const CustomDatePicker = ({ onApply, onCancel, selectedDate, setSelectDate, isSelectDate, label }) => {
    const today = new Date();
    const selectDateRef = useRef()
    const [selectedRange, setSelectedRange] = useState(selectedDate || { from: null, to: null });
    const [hasApplied, setHasApplied] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectDateRef.current && !selectDateRef.current.contains(event.target)) {
                setSelectDate(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (!isSelectDate) {
            if (!hasApplied) {
                setSelectedRange(selectedDate || { from: null, to: null });
            }
            setHasApplied(false);
        }
        if (isSelectDate) {
            setSelectedRange(selectedDate || { from: null, to: null });
        }
    }, [isSelectDate, selectedDate]);

    const isValidRange = !selectedRange?.from || (
        selectedRange?.to && selectedRange.from.getTime() !== selectedRange.to.getTime()
    );

    const handleApply = () => {
        if (isValidRange) {
            setHasApplied(true);
            onApply(selectedRange);
        }
    };

    return (
        <div ref={selectDateRef} className="select-date">
            <button className="selectFields" onClick={(e) => setSelectDate(!isSelectDate)}>
                {label}{" "}
            </button>
            {
                isSelectDate === true &&
                <div className="dropdown addDropdown">
                    <div className="datepicker-popup">
                        <DayPicker
                            mode="range"
                            selected={selectedRange}
                            onSelect={setSelectedRange}
                            defaultMonth={selectedRange?.from || today}
                            captionLayout="buttons"
                        />
                        <div className="save-button-group">
                            <button className="cancel-button" onClick={onCancel}>Cancel</button>
                            <button className="save-button" onClick={handleApply} disabled={!isValidRange}>Apply</button>
                        </div>
                    </div>
                </div>
            }
        </div >
    );
};

export default CustomDatePicker;
